import React from 'react'
import PropTypes from 'prop-types'
import SimpleReactCalendar from 'simple-react-calendar'
import Icon from 'components/Icon'
import range from 'lodash/range'
import classnames from 'classnames'
import partial from 'utils/partial'
import subYears from 'date-fns/sub_years'
import addYears from 'date-fns/add_years'
import getYear from 'date-fns/get_year'
import endOfYear from 'date-fns/end_of_year'
import startOfYear from 'date-fns/start_of_year'

class YearHeaderComponent extends React.Component {
  render() {
    return null
  }
}

export default class YearCalendar extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    selected: PropTypes.object,
    minDate: PropTypes.instanceOf(Date),
    maxDate: PropTypes.instanceOf(Date),
    today: PropTypes.instanceOf(Date),
    onApply: PropTypes.func,
    onSelect: PropTypes.func
  }

  render() {
    const {className} = this.props
    const classNames = classnames('calendar-range-year', className)

    return (
      <div className={classNames}>
        {/* {this.renderYearSelector()} */}
        <div className='calendar-range-year_years'>
          {this.renderYears()}
        </div>
      </div>
    )
  }

  renderYearSelector() {
    const {maxDate, minDate} = this.props
    const start = this.getStartDate()
    const previousYear = subYears(start, 1)
    const nextYear = addYears(start, 1)

    const isPreviousDisabled = getYear(start) <= getYear(minDate)
    const setPreviousYear = !isPreviousDisabled ? partial(this.setYear, previousYear) : null

    const isNextDisabled = getYear(start) >= getYear(maxDate)
    const setNextYear = !isNextDisabled ? partial(this.setYear, nextYear) : null

    const prevClassNames = classnames('calendar-header_button is-prev', {
      'is-disabled': isPreviousDisabled
    })
    const nextClassNames = classnames('calendar-header_button is-next', {
      'is-disabled': isNextDisabled
    })
    return (
      <div className='calendar-range-year_year'>
        <button className={prevClassNames} onClick={setPreviousYear}>
          <Icon
            className='calendar_icon-left'
            name='chevron'
            size='10px'
          />
        </button>
        <div className='calendar-range-year_year_title'>
          {getYear(start)}
        </div>
        <button className={nextClassNames} onClick={setNextYear}>
          <Icon
            className='calendar_icon-right'
            name='chevron'
            size='10px'
          />
        </button>
      </div>
    )
  }

  renderYears() {
    const {minDate, maxDate, today} = this.props
    const start = this.getStartDate()
    const currentYear = getYear(today)
    const yearsRangeMap = range => range.map(year => {
      return {name: year, value: year}
    })
    return range(2020, currentYear + 2).map(year => {
      const isActive = year <= currentYear
      const classNames = classnames('calendar-range-year_item', {
        'is-active': isActive
      })
      return (
        <div
          className={classNames}
          onClick={isActive ? partial(this.onYearSelect, year) : null}
          key={year}
        >
          <div className='calendar-day'>
            {year}
          </div>
        </div>
      )
    })
  }

  onYearSelect = year => {
    const {onApply} = this.props
    const fullYear = `${year}-01-01`
    onApply({
      start: startOfYear(fullYear),
      end: endOfYear(fullYear)
    })
  }

  setYear = year => {
    const {onSelect} = this.props

    onSelect({start: year, end: year})
  }

  getStartDate() {
    const {today, selected: {start}} = this.props

    return start || today
  }
}



// WEBPACK FOOTER //
// ./client/components/Calendar/YearCalendar.js